import React, { Component } from 'react';
import {
  Collapse,
  Navbar,
  NavbarBrand,
  Nav,
  NavItem,
  NavLink,
} from 'reactstrap';
import { NavLink as RRNavLink } from 'react-router-dom';
import classnames from 'classnames';
import { Switch, Route } from 'react-router-dom';
import onClickOutside from 'react-onclickoutside';
import Header from './Header';
import Hamburger from './Hamburger';
import { I18nContext } from '../i18n/I18nContext';

class Navigation extends Component {
  static contextType = I18nContext;

  constructor(props) {
    super(props);

    this.toggle = this.toggle.bind(this);
    this.state = {
      isOpen: false,
    };
  }
  handleClickOutside = evt => {
    this.setState({
      isOpen: false
    });
  }
  toggle() {
    this.setState({
      isOpen: !this.state.isOpen
    });
  }
  selectLanguage = language => {
    this.context.setLanguage(language);
  }
  render() {
    let styler = classnames('');
    const { language, setLanguage, t } = this.context;
    return (
      <div>
        <Navbar fixed="top" inverse toggleable="md" className="navfix bg-brown">
          <Hamburger isOpen={this.state.isOpen} onClick={this.toggle} />
          <NavbarBrand className="brand">
            <img className="logoImg" src={process.env.PUBLIC_URL + "/images/grain-bitess.webp"} alt="Grain Bites" />
          </NavbarBrand>
          <Collapse isOpen={this.state.isOpen} navbar className="toggler" id="main-navigation">
            <Nav className="navigationMenu" navbar>
              <div className="static">
                <NavItem>
                  <NavLink to={process.env.PUBLIC_URL + '/'} exact activeClassName="active" tag={RRNavLink}>{t('nav.home')}</NavLink>
                </NavItem>
                <NavItem>
                  <NavLink to={process.env.PUBLIC_URL + '/Portfolio'} className={styler} activeClassName="active" tag={RRNavLink}>{t('nav.portfolio')}</NavLink>
                </NavItem>
                <NavItem>
                  <NavLink to={process.env.PUBLIC_URL + '/Galerie'} className={styler} activeClassName="active" tag={RRNavLink}>{t('nav.gallery')}</NavLink>
                </NavItem>
                <NavItem>
                  <NavLink to={process.env.PUBLIC_URL + '/Shop'} className={styler} activeClassName="active" tag={RRNavLink}>{t('nav.shop')}</NavLink>
                </NavItem>
                <NavItem>
                  <NavLink to={process.env.PUBLIC_URL + '/Artisan-Breads'} className={styler} activeClassName="active" tag={RRNavLink}>{t('nav.artisanBreads')}</NavLink>
                </NavItem>
              </div>
              <div className="dynamicMenu">
                {Object.keys(this.props.meals).filter(types => types !== 'Bar').map((types, index) =>
                  <NavItem key={types + index}>
                    <NavLink
                      to={process.env.PUBLIC_URL + '/' + types.normalize('NFD').replace(/[\u0300-\u036f]/g, "")} className={styler} activeClassName="active" tag={RRNavLink}>
                      {types === 'Delicious' ? 'Snacks' : types}
                    </NavLink>
                  </NavItem>
                )
                }
                <NavItem>
                  <NavLink to={process.env.PUBLIC_URL + '/Contact'} className={styler} activeClassName="active" tag={RRNavLink}>{t('nav.contact')}</NavLink>
                </NavItem>
                <NavItem className="languageSwitcher">
                  <button
                    type="button"
                    className={classnames('languageButton', { active: language === 'en' })}
                    onClick={() => setLanguage('en')}
                    aria-pressed={language === 'en'}
                  >
                    EN
                  </button>
                  <button
                    type="button"
                    className={classnames('languageButton', { active: language === 'de' })}
                    onClick={() => setLanguage('de')}
                    aria-pressed={language === 'de'}
                  >
                    DE
                  </button>
                  <button
                    type="button"
                    className={classnames('languageButton', { active: language === 'bg' })}
                    onClick={() => setLanguage('bg')}
                    aria-pressed={language === 'bg'}
                  >
                    BG
                  </button>
                </NavItem>
              </div>
            </Nav>
          </Collapse>
        </Navbar>
        <div className="navline"></div>
        <div className="carouselWrapper">
          <Switch>
            <Route exact path={process.env.PUBLIC_URL + "/"} component={Header} />
            <Route path={process.env.PUBLIC_URL + "/About"} render={() => null} />
            <Route path={process.env.PUBLIC_URL + "/Portfolio"} render={() => null} />
            <Route path={process.env.PUBLIC_URL + "/Galerie"} render={() => null} />
          </Switch>
        </div>
      </div>
    );
  }
}

export default onClickOutside(Navigation);
